import { create } from "zustand";

interface ToastState {
  messages: Set<string>;
  add: (msg: string, duration?: number) => void;
  has: (msg: string) => boolean;
  remove: (msg: string) => void;
  reset: () => void;
}

const store = create<ToastState>((set, get) => ({
  messages: new Set<string>(),
  add: (msg: string, duration = 5000) => {
    if (process.env.NODE_ENV === "development") {
      console.debug(`[DBEUG] Suppressed duplicate toast: "${msg}"`);
    }
    const updated = new Set(get().messages);
    updated.add(msg);
    set({ messages: updated });
    setTimeout(() => {
      get().remove(msg);
    }, duration);
  },
  has: (msg: string) => {
    return get().messages.has(msg);
  },
  remove: (msg: string) => {
    const updated = new Set(get().messages);
    updated.delete(msg);
    set({ messages: updated });
  },
  reset: () => set({ messages: new Set() }),
}));

export default store;
